import { Component, OnInit, Input } from '@angular/core';
import { ForgotPasswordFlowConfig, USER_ROLE } from '@ptl/account-management';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  @Input() flowCompleteUrl: string;
  @Input() passwordUpdatedButtonText: string;
  @Input() passwordUpdatedImgSrc: string;
  @Input() passwordUpdatedText: string;
  @Input() isNpnRequiredForAgents: string;
  
  @Input() hideMember: string;
  @Input() hideVisitor: string;
  @Input() hideAgent: string;
  @Input() hideAgencyAdmin: string;
  @Input() hidePlanAdmin: string;

  @Input() memberSuspendedMsg: string;
  @Input() visitorSuspendedMsg: string;
  @Input() agentSuspendedMsg: string;

  @Input() memberAssistanceMsg: string;
  @Input() visitorAssistanceMsg: string;
  @Input() agentAssistanceMsg: string;

  flowConfig: ForgotPasswordFlowConfig;

  constructor() { }

  ngOnInit() {
    this.flowConfig = {
      flowCompleteUrl: this.flowCompleteUrl,
      passwordUpdatedButtonText: this.passwordUpdatedButtonText,
      passwordUpdatedImgSrc: this.passwordUpdatedImgSrc,
      passwordUpdatedText: this.passwordUpdatedText,
      isNPNRequiredForAgents: this.isNpnRequiredForAgents === 'true',
      hideMember: this.hideMember === 'true',
      hideVisitor: this.hideVisitor === 'true',
      hideAgent: this.hideAgent === 'true',
      hideAgencyAdmin: this.hideAgencyAdmin === 'true',
      hidePlanAdmin: this.hidePlanAdmin === 'true',
      accountSuspendedMessage: {
        [USER_ROLE.MEMBER]: this.memberSuspendedMsg,
        [USER_ROLE.VISITOR]: this.visitorSuspendedMsg,
        [USER_ROLE.AGENT]: this.agentSuspendedMsg,
      },
      verificationAssistanceMessage: {
        [USER_ROLE.MEMBER]: this.memberAssistanceMsg,
        [USER_ROLE.VISITOR]: this.visitorAssistanceMsg,
        [USER_ROLE.AGENT]: this.agentAssistanceMsg,
      },
    };
  }
}